module.exports = __webpack_public_path__ + "static/img/2.549d352.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/2.png
// module id = ET8W
// module chunks = 0